import React from "react";
import NavBar from "./NavBar";
import Subbar from "./subbar";
export default function RightAll() {
  return ( 
    <div id="right-all">
      <div id="left-subbar">
        <h1>Coming Soon</h1>
      </div>
      <div id="Right-content">
        <NavBar />
        <h1>HOME PAGE IS COMING SOON....</h1>
      </div>
    </div>
  );
}
